import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete,
}) {
  return (
    <>
      <FormSection
        disableAll={disableAll}
        sectionName="SIGNING"
        errors={formikProps.errors}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        values={formikProps.values}
        setFieldValue={formikProps.setFieldValue}
        setFieldError={formikProps.setFieldError}
        formikRef={formikRef}
        idOperation={idOperation}
        idOperationParent={idOperationParent}
        idProduct={idProduct}
        isSelectMarketsScreen
      />
    </>
  )
}

const components = {
  RenderSection
}

export { components }